<template>
  <div class="mobile-menu">
    <div class="container p-9">
      <div class="row mobile_header">
        <span class="mobile_header__menu-text">{{$bimTranslate('header.menu', activeLang)}}</span>
        <div class="mobile-menu__close" @click="handleMobileMenu" />
      </div>

      <div class="row mobile_lk mx-0 my-9">
        <div class="d-flex justify-center flex-column align-self-center posr dropdown profile-block w-100 h-100">
          <div v-if="!user" class="mobile-menu__wrp">
            <a class="mobile-menu__button-top login open-modal login-btn" @click="$emit('login-clicked')" id="open-button">
              <span class="nowrap">{{$bimTranslate('header.login', activeLang)}}</span>
            </a>
          </div>
          <div v-else>
            <a class="nav-link user_auth align-center d-flex w-100" href="https://lk.bimlib.pro/" rel="nofollow">

              <div class="pr-4 ava-block--mobile">
                <Avatar
                  :user="user"
                  :imgHost="imgHost"
                />
              </div>

              <div class="mobile-profile">
                <div class="mobile-profile__name">
                  {{ userInitials }}
                </div>
                <span class="mobile-profile__messages">
                  <span v-if="user.count_new_message">
                    {{user.count_new_message}}
                    {{messageCountText}}
                  </span>
                  <span v-else>{{$bimTranslate('header.noNewMessages', activeLang)}}</span>
                </span>
              </div>
            </a>

            <ul class="profile-list">
              <li class="profile-list__item pt-6" @click="menuItemClicked('home')">
                <div class="pSmall" href="" rel="nofollow">
                  {{$bimTranslate('header.personalAccount', activeLang)}}
                </div>
              </li>

              <li class="profile-list__item pt-3" @click="menuItemClicked('messages')">
                <div class="pSmall" href="" rel="nofollow">
                  {{$bimTranslate('header.messages', activeLang)}}
                </div>
              </li>
              <li class="profile-list__item pt-3" @click="menuItemClicked('models')">
                <div class="pSmall" href="" rel="nofollow">
                  {{$bimTranslate('header.models', activeLang)}}
                </div>
              </li>

              <li class="profile-list__item pt-3" @click="menuItemClicked('statistic')">
                <div class="pSmall" href="" rel="nofollow">
                  {{$bimTranslate('header.statistics', activeLang)}}
                </div>
              </li>

              <li class="profile-list__item pt-6" @click="menuItemClicked('logout')">
                <div class="pSmall op05" href="" rel="nofollow">
                  {{$bimTranslate('header.logout', activeLang)}}
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <!-- навигация -->

      <MobileHeadLinks :links="links" :headerLinkTarget="headerLinkTarget" />

      <div class="row mobile_contact mx-0">
        <ul class="contacts-list w-100">
          <li class="contacts-item mb-3"><a href="tel:88005002575" rel="nofollow"
              class="contacts-link fw-bold">8
              800 500-25-75</a></li>
          <li class="contacts-item mb-3"><a href="tel:+74954452575" rel="nofollow"
              class="contacts-link fw-bold">+7
              495 445-25-75</a></li>
        </ul>
      </div>

      <SocialLinks style="margin-top: 30px; justify-content: space-between;" />

      <!--      <ChangeLang-->
      <!--        v-if="makeChangeLanguage"-->
      <!--        class="change-lang py-7"-->
      <!--        :activeLang="activeLang"-->
      <!--        @change-lang="$emit('change-lang')"-->
      <!--      />-->

    </div>
  </div>
</template>

<script>
import Avatar from '@/components/core/bimHeader/Avatar'
import SocialLinks from '@/components/core/social-links'

import { declOfNum } from '@/utils/helpers'

// import ChangeLang from './ChangeLang'
import MobileHeadLinks from './MobileHeadLinks'

export default {
  components: {
    // ChangeLang,
    MobileHeadLinks,
    Avatar,
    SocialLinks
  },
  props: {
    user: Object,
    links: Array,
    headerLinkTarget: String,
    activeLang: String,
    makeChangeLanguage: Boolean,
    imgHost: String,
    handleMobileMenu: {
      type: Function,
      default: () => () => {}
    }
  },
  methods: {
    menuItemClicked (val) {
      this.$emit('menuItemClicked', val)
    },
  },
  computed: {
    messageCountText () {
      return declOfNum(this.user.count_new_message, ['новое сообщение', 'новых сообщения', 'новых сообщений'])
    },
    userInitials () {
      const { firstName, lastName } = this.user
      let initials = firstName

      if (lastName) {
        initials += ` ${lastName}.`
      }

      return initials
    }
  }
}
</script>

<style lang="scss" scoped>
.ava__logo {
  width: 50px;
  height: 50px;
  display: block;
}

.w-100 {
  width: 100%;
}

.container {
  height: fit-content;
  width : 100%;
  box-sizing: border-box;
  margin: 0 auto;
  max-width: $breakpoint-xxl;
  padding: 0 $gap-xxl;

  @media screen and (min-width: $breakpoint-xl) and (max-width: $breakpoint-xxl) {
    max-width: $breakpoint-xl;
    padding: 0 $gap-xl;
  }
  @media screen and (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl) {
    max-width: $breakpoint-lg;
    padding: 0 $gap-lg;
  }
  @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-lg) {
    max-width: $breakpoint-md;
    padding: 0 $gap-md;
  }
  @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-md) {
    max-width: $breakpoint-sm;
    padding: 0 $gap-sm;
  }
  @media screen and (min-width: $breakpoint-xs) and (max-width: $breakpoint-sm) {
    max-width: 100%;
    padding: 0 $gap-xs;
  }

  &-fluid {
    max-width: 100%;
    & > .row {
      margin : 0;
    }
  }
}

.br50p {
  border-radius: 50%;
  overflow: hidden;
}

.op05 {
  opacity: .5;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

.mobile-menu {
  display: flex;
  overflow: auto;
  z-index: 9998;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: white;
  font-family: Bimlib-Helvetica, sans-serif;

  @media screen and (min-width: $breakpoint-lg) {
    display: none;
  }

  &__close {
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: relative;
    border-radius: 40px;
    background-color: #F6F6F6;
    &::before, &::after {
      content: '';
      width: 18px;
      height: 2px;
      position: absolute;
      left: 50%;
      top: 50%;
      background-color: #4d4d4d;
    }
    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
}

.mobile_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ava-block--mobile {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile_header__menu-text {
  font-size: 24px;
}

.profile-list__item {
  cursor: pointer;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: .2px;
}

.contacts-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.contacts-item {
  font-weight: bold;
  font-size: 14px;
  color: #4d4d4d;
  line-height: 1.36;
}

.mobile_socials {
  padding-top: 35px;
  justify-content: center;
}

.social-list li:not(:last-child) {
  margin-right: 16px;
}

.social-link {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 30px;
  height: 30px;
  font-size: 20px;
  background-color: #f2fbfa;
  color: $primary-color;
}

.change-lang {
  display: flex;
  justify-content: center;
}

.mobile-profile__name {
  font-size: 14px;
  font-weight: bold;
}

.mobile-profile__messages {
  letter-spacing: 0.5px;
  opacity: 0.5;
  font-size: 12px;
}

.mobile-menu__wrp {
  display: flex;
  flex-direction: column;
}

.mobile-menu__button-top {
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 3px;
  text-align: center;
  padding: 18px 68px;

  &.get-service {
    box-shadow: 0 10px 10px 0 $primary-color-50;
    background-color: $primary-color;

    .button {
      color: $white-color;
    }
  }

  &.login {
    background-color: $white-color-100;

    .button {
      color: $primary-color;
    }
  }

  .button {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.36;
  }
}

.icon-telegram:before {
  color: $primary-color !important;
}
</style>
